import React, { useEffect } from "react";
import Navigation from "../components/site/Navigation";
import Footer from "../components/site/Footer";

const TODAY = "May 23, 2026";

const Section = ({ title, children }) => (
  <section className="mb-12">
    <h2 className="font-serif text-2xl text-themed mb-4">{title}</h2>
    <div className="text-themed-muted leading-relaxed space-y-3 text-[15px]">
      {children}
    </div>
  </section>
);

const PrivacyPage = () => {
  useEffect(() => {
    document.title = "Privacy Policy · Authentic Momentum";
  }, []);
  return (
    <>
      <Navigation />
      <main
        data-testid="privacy-page"
        className="min-h-screen bg-themed text-themed pt-32 pb-24"
      >
        <article className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-gold mb-4">
            Trust · Transparency
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl text-themed mb-3 leading-tight">
            Privacy Policy
          </h1>
          <p className="text-themed-muted/70 text-sm mb-10">Last updated: {TODAY}</p>

          <Section title="What we collect">
            <p>
              Authentic Momentum (operated by Cyrus Prescod under Damone &amp;
              Associates LLC) collects only what is needed to deliver our products
              and respond to your inquiries:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Account / order data</strong>. Name, email, and order details when you purchase the Book ($19.95) or Personal Action Plan ($49.99).</li>
              <li><strong>Personal Action Plan &amp; Snapshot responses</strong>. Your answers when you complete the Clarity Snapshot or Personal Action Plan intake.</li>
              <li><strong>Behavioral signals</strong>. Anonymous interaction data (pages viewed, sections opened, time on site) used to personalize the experience and route follow-up.</li>
              <li><strong>Attribution data</strong>. Referral source (e.g., LinkedIn, podcast) when present in the URL.</li>
            </ul>
          </Section>

          <Section title="How we use it">
            <p>
              We use your information to (1) deliver the products you purchased,
              (2) respond to consultation requests, (3) personalize the
              recommendations you see on the site, and (4) send transactional
              emails (order confirmations, intake links, scheduling). We do not
              sell or rent your data to third parties.
            </p>
          </Section>

          <Section title="Payments">
            <p>
              Payments are processed by <strong>Stripe</strong>. We never see or
              store your full card details. Stripe's privacy notice is at{" "}
              <a className="text-gold hover:underline" href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a>.
            </p>
          </Section>

          <Section title="Cookies &amp; local storage">
            <p>
              We use <strong>essential local storage</strong> to remember your
              session, your Snapshot result, and which sections you've explored
              so the site adapts to where you are in the journey. We do not use
              cross-site advertising cookies.
            </p>
          </Section>

          <Section title="Your rights">
            <p>
              You may request access to, correction of, or deletion of your data
              at any time by emailing the address below. We will respond within
              30 days.
            </p>
          </Section>

          <Section title="Contact">
            <p>
              Cyrus Prescod · Authentic Momentum<br />
              <a className="text-gold hover:underline" href="tel:+19177228598">(917) 722-8598</a>
            </p>
          </Section>
        </article>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPage;
